import { render } from "./tickets-draft.vue?vue&type=template&id=0665d2de"
import script from "./tickets-draft.vue?vue&type=script&lang=js"
export * from "./tickets-draft.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__